import { BurnoutCheckbox } from './BurnoutCheckbox';
import { BurnoutMultiSelect } from './BurnoutMultiSelect';
import { BurnoutRichTextEditor } from './BurnoutRichTextEditor';
import { BurnoutSelectField } from './BurnoutSelectField';
import { BurnoutSubmitButton } from './BurnoutSubmitButton';
import { BurnoutTextAreaField } from './BurnoutTextAreaField';
import { BurnoutTextField } from './BurnoutTextField';
import { GlassCheckbox } from './GlassCheckbox';
import { GlassRichTextEditor } from './GlassRichTextEditor';
import { GlassSelectField } from './GlassSelectField';
import { GlassTextAreaField } from './GlassTextAreaField';
import { GlassTextField } from './GlassTextField';
import { MonsterCheckbox } from './MonsterCheckbox';
import { MonsterGlassSubmitButton } from './MonsterGlassSubmitButton';
import { MonsterMultiSelect } from './MonsterMultiSelect';
import { MonsterRichTextEditor } from './MonsterRichTextEditor';
import { MonsterSelectField } from './MonsterSelectField';
import { MonsterSubmitButton } from './MonsterSubmitButton';
import { MonsterTextAreaField } from './MonsterTextAreaField';
import { MonsterTextField } from './MonsterTextField';

import { createFormHook, createFormHookContexts } from '@tanstack/react-form';

export const { fieldContext, useFieldContext, formContext, useFormContext } = createFormHookContexts();

export const { useAppForm } = createFormHook({
  fieldComponents: {
    GlassTextAreaField,
    GlassRichTextEditor,
    BurnoutCheckbox,
    BurnoutMultiSelect,
    BurnoutRichTextEditor,
    BurnoutSelectField,
    BurnoutTextAreaField,
    BurnoutTextField,
    GlassCheckbox,
    GlassTextField,
    MonsterCheckbox,
    MonsterMultiSelect,
    MonsterRichTextEditor,
    MonsterSelectField,
    MonsterTextAreaField,
    MonsterTextField,
    GlassSelectField
  },
  formComponents: {
    BurnoutSubmitButton,
    MonsterSubmitButton,
    MonsterGlassSubmitButton
  },
  fieldContext,
  formContext
});
